<template>
    <div class="container-fluid position-relative bg-BAT">
        <loading v-if="loading !== 0"></loading>
        <div>
            <div class="container watch-container py-4">
                <div>
                    <div class="breadcrumbs-retos d-flex flex-column pb-2">
                        <div>
                            <a href="/home-bat">
                                <img src="/img/icons/homeBread.svg" alt="" />
                                Home
                            </a>
                            <a id="practica" class="link cursor-pointer link-active-bread"
                                href="/retos?option=todos">Gana puntos</a>
                            <span id="optionP" class="d-none color-active-miga"></span>
                        </div>
                    </div>
                    <a class="pb-2 pt-2" href="/home-bat"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
                <!-- <div v-if="activeSeason != null && [1, 2, 3].includes(client_segment)" class="cursor-pointer" @click="showSeasonModal = true"> -->
                <!--                <div v-if="activeSeason != null" class="cursor-pointer" @click="showSeasonModal = true">-->
                <!--                    <img src="/../img-version2/icons/rash-watch.svg" alt="">-->
                <!--                </div>-->
            </div>

            <div class="container mt-3">
                <div class="row d-flex header-season">
                    <div class="col-12 col-md-6">
                        <div class="header-portfolio d-flex flex-column description-win ">
                            <h5 class="text-title-bat mb-2">{{ dataWinPointsSettings.title }}</h5>
                            <p v-if="isLinked" class="fs-6 text-bat mb-0">
                                {{ dataWinPointsSettings.description }}
                                <strong class="text-title-bat text-orange fs-5">
                                    {{ dataWinPointsSettings.pointsByWin }}
                                </strong> ¡Completa las actividades!
                            </p>
                            <p v-else class="fs-6 text-bat mb-0">
                                <!-- Explora nuestras opciones y descubre todo lo que puedes hacer. ¡Completa las actividades! -->
                                Explora nuestras opciones y aprovecha la oportunidad para completar las actividades.
                            </p>
                        </div>
                    </div>

                        <!-- Sección "Tu racha"   -->
                       <div v-if="activeSeason != null && !isStaffUser" class="align-items-center rounded-3 p-3 mt-3"
                        style="border: 1px solid #FBFBFB; background: #FFF; box-shadow: 0px 2px 4px 0px rgba(82, 100, 100, 0.10); width: 330px;"
                        @click="showSeasonModal = true">
                        <div class="d-flex">
                            <img :src="getSeasonImage" alt="" class="me-3">
                            <div>
                                <h5 class="mb-1 text-title-bat">Tu racha</h5>
                                <p class="mb-2 text-bat">{{ getSeasonDescription }}</p>
                            </div>
                        </div>
                        <div v-if="seasonStreak === 'lose'" style="border-left: 4px solid var(--Semantic-Danger-100, #F00); background: #FFDED9; padding: 5px;" class="mt-3 mb-3 text-bat">
                            <p class="mb-0">Se ha roto tu racha</p>
                        </div>
                        <button class="w-100 mx-1 btn btnBlue text-title-bat rounded-3">
                            <span>Ver racha</span>
                        </button>
                    </div>

                        <!-- Nueva seccion de racha usuario staff -->
                            <season-status-staff v-if="isStaffUser" :client_segment="client_segment"
                                                 :segments_staff="staff_segments" :home="false" ></season-status-staff>

                </div>
            </div>

            <div class="container my-3">
                <div class="row flex-nowrap overflow-auto gap-3">
                    <div v-for="(category, index) in dataWinPointsCategories" :key="index" v-if="(activeSeason != null) || (activeSeason == null && category.categoryDB !== 'racha')"
                        class="my-4 px-0 col-4 col-md-auto col-lg-2 text-center text-bat">
                        <button :id="category.id + '-' + category.categoryDB" :title="category.categoryDB"
                            class="rounded-5 border-none border-0 px-2 py-2 text-bat mx-2 w-100"
                            :class="{ 'bg-darkblue text-white w-100': activeCategory == category.categoryDB, 'bg-white': activeCategory != category.categoryDB }"
                            @click="setActive(category.categoryDB)">
                            {{ category.category }}
                        </button>
                    </div>
                </div>
            </div>


            <div class="container mb-4">

                <el-button type="text" class="text-black text-bat" @click="dialogTableVisibleFilter = true">
                    Filtrar por:
                    <img class="ms-2" src="/img/icons/filto-winpoints.svg" alt="filtro">
                </el-button>

                <div class="container">
                    <div class="row d-flex justify-content-center">

                        <!-- Win points cards -->
                        <div v-for="(card, index) in currentPageProducts" :key="index"
                            class="text-bat col-12 col-md-6 col-lg-4 mb-3">
                            <a :id="card.id + '-' + card.option"
                                :title="(card.challenge_name ?? card.name ?? card.title) + '-' + card.option"
                                class="text-bat text-black text-decoration-none"
                                :href="cardLinkAndStatus(card).activityUrl" @click="() => showModalRevision(card)">
                                <win-points-card :card="card" :newWinPoints="newWinPoints"
                                    :returnChallenges="returnChallenges"
                                    :activityStatus="cardLinkAndStatus(card).activityStatus"
                                    :showExpirationDate="cardLinkAndStatus(card).showExpirationDate"
                                    :isSeason="isSeason"
                                    :isStaffUser="isStaffUser"
                                    :isLinked="isLinked"
                                ></win-points-card>
                            </a>
                        </div>
                        <!-- /Win points cards -->

                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                    <button @click="prevPage" :disabled="pageSelected === 1" class="bg-transparent border-0"> &lt;
                    </button>
                    <div class="text-bat">
                        <span v-if="visiblePages[0] > 1">...</span>
                        <span v-for="page in visiblePages" :key="page" @click="goToPage(page)"
                            class="mx-3 mx-md-4 cursor-pointer"
                            :class="{ 'text-title-bat text-orange': page === pageSelected }">{{ page }}</span>
                        <span v-if="visiblePages[visiblePages.length - 1] < pagesTotals">...</span>
                    </div>
                    <button @click="nextPage" :disabled="pageSelected === pagesTotals" class="bg-transparent border-0">
                        > </button>
                </div>
            </div>

            <!-- MODAL el filtro-->
            <el-dialog :visible.sync="dialogTableVisibleFilter"
                :width="$mq === 'sm' ? '300px' : $mq === 'xl' ? '300px' : '300px'" class="filterDialog" center>
                <el-radio-group class="d-flex flex-column text-bat" v-model="orderFilterOption">
                    <el-radio class="mb-2" :label="1">De la A a la Z</el-radio>
                    <el-radio class="mb-2" :label="2">De menor a mayor (PTS)</el-radio>
                    <el-radio class="mb-2" :label="3">De mayor a menor (PTS)</el-radio>
                </el-radio-group>
                <span slot="footer" class="dialog-footer d-flex justify-content-center">
                    <el-button class="btn btnBlue border-0 text-title-bat" type="primary"
                        @click="changeOrderFilter(orderFilterOption)">Aplicar</el-button>
                </span>
            </el-dialog>

            <el-dialog :visible.sync="modal_revision" :width="$mq === 'sm' ? '95%' : 'md' ? '35%' : '20%'"
                :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true">
                <div class="d-flex flex-column justify-content-center align-items-center text-center text-break">
                    <i class="fa-solid fa-triangle-exclamation fs-1 mb-3" style="color: #fec52f;"></i>
                    <h4 class="text-indigo-darkness">Tu quiz está en proceso de revisión.</h4>
                </div>
            </el-dialog>

            <el-dialog :visible.sync="showSeasonModal" :width="$mq === 'sm' ? '95%' : 'md' ? '35%' : '20%'"
                :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true">
                <div v-if="activeSeason != null">
                    <season :season_id="activeSeason.id" :staff_segments="staff_segments" :client_segment="client_segment"

                    ></season>
                </div>
            </el-dialog>
        </div>

        <div class="ranking-container" v-if="activeSeason != null">
            <img src="/img-version2/icons/help.svg" alt="Ranking Season" class="img-fluid image-ranking bottom-ranking cursor-pointer"
            @click="modalRanking = true">
        </div>

        <el-dialog :visible.sync="modalRanking" :width="$mq === 'sm' ? '95%' : $mq === 'md' ? '35%' : '20%'"
            :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true">
            <ranking :staff_segments="staff_segments" :client_segment="client_segment"></ranking>
        </el-dialog>
    </div>
</template>

<script>
import Slick from "vue-slick";
import 'slick-carousel/slick/slick.css';
import { EventBus } from "../../app";
export default {
    components: { Slick },
    props: {
        url_media: {
            default: '',
        },
        client_segment: {
            type: Number,
            default: null,
        },
        staff_segments: {
            default: [],
        },
        // active_season: {
        //     default: null,
        // },
    },
    data() {
        return {
            loading: 0,
            dialogTableVisibleFilter: false,
            dataWinPointsSettings: [],
            pageNumbers: [],
            currentPage: 1,
            lastPage: null,
            modal_revision: false,
            page: 1,
            activeCategory: 'todos',
            selectedCategory: '',
            activeLink: '',
            dataWinPointsCategories: [
                { id: 1, category: "Todas", categoryDB: "todos" },
                { id: 5, category: "Racha", categoryDB: "racha" },
                { id: 2, category: "Retos", categoryDB: "challenge" },
                { id: 3, category: "Encuestas", categoryDB: "survey" },
                { id: 4, category: "Aprendizaje", categoryDB: "learning" },
                {id: 4, category:"Entretenimiento", categoryDB:"entertainment"},
            ],
            dataWinPoints: [],
            orderFilterOption: null,
            slickOptionsCategories: {
                dots: false,
                arrows: false,
                infinite: false,
                centerMode: false,
                autoplay: false,
                slidesToShow: 10,
                slidesToScroll: 2,
                pauseOnFocus: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 560,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 3.5,
                            slidesToScroll: 1,
                        }
                    }
                ]
            },
            // new paginate
            pageSelected: 1,
            productsForPage: 8,
            activeSeason: null,
            showSeasonModal: false,
            modalRanking: false,
            activeLapse: '',
            seasonStreak: '',
            streakIcons: [
                { src: '/img-version2/icons/season-staff/yellow-flame.svg' },
                { src: '/img-version2/icons/season-staff/yellow-flame.svg' },
                { src: '/img-version2/icons/season-staff/yellow-flame.svg' },
                { src: '/img-version2/icons/season-staff/yellow-flame.svg' }
            ],
            isLinked: false,
        }
    },
    created() {
        // this.getWinPoints(this.activeCategory, this.page);
        const urlParams = new URLSearchParams(window.location.search);
        const categoryParam = urlParams.get('option');
        this.pageSelected = parseInt(urlParams.get('page')) || 1;
        if (categoryParam !== 'todos' && categoryParam != null) {
            this.activeCategory = categoryParam;
            this.isActive(this.activeCategory);
            this.getWinPoints(this.activeCategory, this.page);
        } else {
            this.activeCategory = 'todos';
            this.getWinPoints(this.activeCategory, this.page);
        }
        this.getActiveSeason()
        EventBus.$emit('refresh-points', true);
    },
    computed: {
        pagesTotals() {
            return Math.ceil(this.dataWinPoints.length / this.productsForPage);
        },
        visiblePages() {
            let startPage = Math.max(1, this.pageSelected - 4);
            let endPage = Math.min(startPage + 4, this.pagesTotals); // 4 páginas a la izquierda, 4 a la derecha y la actual
            if (endPage - startPage < 4) {
                startPage = Math.max(1, endPage - 4);
            }
            return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
        },
        currentPageProducts() {
            //this.productsForPage = this.mq;
            const startIndex = (this.pageSelected - 1) * this.productsForPage;
            const endIndex = startIndex + this.productsForPage;
            return this.dataWinPoints.slice(startIndex, endIndex);
        },
        getSeasonImage() {
            if (!this.activeLapse) return '';

            if (this.activeLapse === 'in_progress') {
                return '/img-version2/icons/initial-orange-rocket.svg';
            } else if (this.activeLapse === 'in_coming') {
                return '/img-version2/icons/initial-gray-rocket.svg';
            } else if (this.activeLapse === 'completed') {
                return '/img-version2/icons/initial-green-rocket.svg';
            } else {
                return '';
            }
        },
        getSeasonDescription() {
            if (!this.activeLapse) return '';

            if (this.activeLapse === 'in_progress') {
                return 'Estás a punto de perder tu racha semanal. Ingresa y haz una actividad para salvarla.';
            } else if (this.activeLapse === 'in_coming') {
                return 'Completa las actividades en racha y gana el premio.';
            } else if (this.activeLapse === 'completed') {
                return '¡En racha! Regresa la próxima semana para mantenerla.';
            } else {
                return '';
            }
        },
        isStaffUser() {
            return this.staff_segments.includes(this.client_segment);
        }
    },
    mounted() {
        this.validateLinkingDate();
    },
    methods: {
        getWinPoints(selectedCategory, page) {
            this.loading++;
            //this.pageSelected = 1;
            selectedCategory = this.activeCategory;
            let apiUrl = `/get-win-points`;
            if (selectedCategory !== 'todos') {
                apiUrl += `?option=${selectedCategory}`;
            }
            // console.log(apiUrl);
            axios.get(apiUrl).then(({ data }) => {
                this.dataWinPointsSettings = data.settings;
                this.dataWinPoints = data.data;
                this.loading--;
                // console.log(this.orderFilterOption);
                //this.isActive(this.activeCategory);
                this.applyOrderFilter();
            });
        },
        setActive: function (category) {
            this.pageSelected = 1;
            this.activeCategory = category;
            this.getWinPoints(category);
            this.isActive(this.activeCategory);
        },
        isActive: function (categoryActive) {
            if (categoryActive == 'todos') {
                window.history.pushState({}, '', '?page=' + this.pageSelected);
            } else {
                window.history.pushState({}, '', '?page=' + this.pageSelected + '&option=' + categoryActive);
            }
        },
        prevPage() {
            if (this.pageSelected > 1) {
                this.pageSelected--;
            }
            this.isActive(this.activeCategory)
        },
        nextPage() {
            if (this.pageSelected < this.pagesTotals) {
                this.pageSelected++;
            }
            this.isActive(this.activeCategory)
        },
        goToPage(page) {
            if (page >= 1 && page <= this.pagesTotals) {
                this.pageSelected = page;
            }
            this.isActive(this.activeCategory)
        },
        applyOrderFilter() {
            let dataToOrder = [];
            if (Array.isArray(this.dataWinPoints)) {
                dataToOrder = this.dataWinPoints;
            } else if (typeof this.dataWinPoints === 'object' && Object.keys(this.dataWinPoints).length > 0) {
                dataToOrder = Object.values(this.dataWinPoints);
            } else {
                console.error('dataWinPoints no es un array ni un objeto válido');
                return;
            }
            if (this.orderFilterOption === 1) {
                const customSort = (a, b) => {
                    const propertyA = a.title || a.challenge_name || a.name;
                    const propertyB = b.title || b.challenge_name || b.name;
                    return propertyA.localeCompare(propertyB);
                };
                dataToOrder.sort(customSort);
            } else if (this.orderFilterOption === 2) {
                dataToOrder.sort((a, b) => a.points_to_win - b.points_to_win);
            } else if (this.orderFilterOption === 3) {
                dataToOrder.sort((a, b) => b.points_to_win - a.points_to_win);
            }
            this.dataWinPoints = dataToOrder;
        },
        changeOrderFilter(order) {
            this.orderFilterOption = order;
            this.dialogTableVisibleFilter = false;
            this.applyOrderFilter();
        },
        filter(type, arrayData) {
            this.loading++
            var typeCategory = document.querySelector(`input[name="${type}"]:checked`).value;
            switch (typeCategory) {
                case 'fromAToZ':
                    // Copiar el array original para evitar modificar el original
                    const copyArray = [...arrayData];

                    // Utilizar el método sort con una función de comparación basada en el título
                    copyArray.sort(function (a, b) {
                        const tituloA = (a.title || a.challenge_name || a.name).toUpperCase();
                        const tituloB = (b.title || b.challenge_name || b.name).toUpperCase();

                        if (tituloA < tituloB) {
                            return -1;
                        }
                        if (tituloA > tituloB) {
                            return 1;
                        }
                        return 0;
                    });

                    // Mostrar el array ordenado
                    this.dataWinPoints = copyArray;
                    break;

                case 'fromSmallToLarge':
                    // Definir una función de comparación para ordenar de menor a mayor según los puntos
                    const comparePoints = (a, b) => {
                        // Comparar los puntos y devolver un valor negativo, positivo o cero según sea necesario
                        return a.points_to_win - b.points_to_win;
                    };

                    // Utilizar el método sort con la función de comparación para ordenar el array
                    arrayData.sort(comparePoints);

                    // Mostrar el array ordenado
                    this.dataWinPoints = arrayData;
                    break;
                case 'fromLargeToSmall':
                    // Definir una función de comparación para ordenar de mayor a menor según los puntos
                    const comparePointsDescending = (a, b) => {
                        // Comparar los puntos y devolver un valor negativo, positivo o cero según sea necesario
                        return b.points_to_win - a.points_to_win;
                    };

                    // Utilizar el método sort con la función de comparación para ordenar el array
                    arrayData.sort(comparePointsDescending);

                    // Devolvemos el array ordenado
                    this.dataWinPoints = arrayData;
                    break;
            }
            this.dialogTableVisibleFilter = false;
            this.loading--
        },
        newWinPoints(card) {
            let newCard = false;
            if (card.option === 'learning') {
                if (card.users.length === 0) {
                    newCard = true;
                }
            } else if (card.option === 'survey') {
                if (card.client_survey.length === 0) {
                    newCard = true;
                }
            } else if (card.option === 'challenge') {
                if (card.client.length === 0) {
                    newCard = true;
                }
            }
            return newCard;
        },
        isSeason(card) {
            return card.lapse_id !== null && card.lapse_id !== undefined;
        },
        returnChallenges(type, id) {
            let challenge = '';
            switch (type) {
                case 'photo':
                    challenge = `retos/foto/${id}`;
                    break;
                case 'video':
                    challenge = `retos/video/${id}`;
                    break;
                case 'audio':
                    challenge = ``;
                    break;
                case 'alphabet-soup':
                    challenge = `retos/sopa-letras/${id}}`;
                    break;
                case 'crossword':
                    challenge = `retos/crucigrama/${id}}`;
                    break;
                case 'uniq-question':
                    challenge = `retos/only-answer/${id}`;
                    break;
                case 'open-question':
                    challenge = `retos/free-answer/${id}`;
                    break;
                case 'memento':
                    challenge = `retos/memento/${id}`;
                    break;
            }
            return challenge;
        },

        cardLinkAndStatus(card) {
            const { id } = card
            let activityStatus = ''
            let activityUrl = '#'
            let showExpirationDate = true

            switch (card.option) {
                case 'learning':
                    if (card.users.length === 0 || (!card.has_quiz && card.users[0].pivot.status === 'pending')) {
                        activityStatus = 'Comenzar'
                        activityUrl = `/learning/${id}`
                    } else if (card.has_quiz && card.users[0].pivot.status === 'pending') {
                        activityStatus = 'Reanudar'
                        activityUrl = `/learning/${id}`
                    } else if (card.users[0].pivot.status === 'completed') {
                        activityStatus = 'Volver a ver'
                        activityUrl = `/learning/${id}`
                        showExpirationDate = false

                        if (card.has_quiz && card.users.length) {
                            if (card.users[0].pivot.quiz_presented === 0) {
                                activityStatus = 'Presentar quiz'
                                activityUrl = `/learning/${id}/quiz`
                                showExpirationDate = true
                            } else if (card.users[0].pivot.score === null) {
                                activityStatus = 'Retroalimentación'
                                activityUrl = '#'
                            } else if (card.users[0].pivot.score != null) {
                                activityStatus = 'Retroalimentación'
                                activityUrl = `/learning/${id}/quiz/feedback`
                            }
                        }
                    }

                    return { activityStatus, activityUrl, showExpirationDate }

                case 'survey':
                    if (card.client_survey.length === 0 || card.client_survey[0] == []) {
                        activityStatus = 'Comenzar'
                        activityUrl = `/survey/${id}`
                    } else if (card.client_survey[0].status === 'pending') {
                        activityStatus = 'Continuar'
                        activityUrl = `/survey/${id}`
                    } else if (card.client_survey[0].status === 'finish') {
                        showExpirationDate = false
                    }

                    return { activityStatus, activityUrl, showExpirationDate }

                case 'challenge':
                    if (card.client && card.client.length === 0 || card.client[0].pivot.is_approved === 'read') {
                        activityStatus = 'Comenzar'
                        activityUrl = this.returnChallenges(card.challenge_type_name, id)
                    } else {
                        showExpirationDate = false
                    }

                    return { activityStatus, activityUrl, showExpirationDate }

                case 'entertainment':
                    activityStatus = 'Comenzar';
                    activityUrl = `/entertainment/search_character/${id}`;

                    if (card.client && card.client.length > 0 && card.client[0].pivot.status === 'true') {
                        activityStatus = '';
                        activityUrl = '#';
                        showExpirationDate = false;
                    } else if (card.client.length === 0) {
                        activityStatus = 'Comenzar';
                        activityUrl = `/entertainment/search_character/${id}`;
                        showExpirationDate = true;
                    }
                    return { activityStatus, activityUrl, showExpirationDate }
            }
        },
        showModalRevision(card) {
            if (card.has_quiz && card.users[0].pivot.quiz_presented) {
                return this.modal_revision = card.users[0].pivot.score === null ? true : false
            }
        },
        getActiveSeason() {
            this.loading++
            axios.get(`/get-active-season`)
                .then(({ data }) => {
                    this.activeSeason = data.season;
                    this.activeLapse = data.active_lapse;
                    this.seasonStreak = data.season_streak;
                    this.loading--
                })

        },
        validateLinkingDate(){
            axios
                .get(`/validate-linking-date`)
                .then(({ data }) => {
                    this.isLinked = data.is_linked;
                })
                .catch(error => {
                    console.error('Error al obtener el estado de vinculación al punto de venta:', error);
                    this.isLinked = false;
                });
        },
    }
}
</script>
